import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import { STEPS, STEP_SCHEMAS } from '../../static-data/DropdownOptions';
import {
  OrganizationFormHeader,
  StepIndicator,
  StepOne,
  StepTwo,
} from './OrganizationFormSteps';

const INITIAL_VALUES = {
  organization:     '',
  industry:         '',
  industry_other:    '',
  orgCountryCode:      'IN',
  orgPhoneNumber:      '',
  website:          '',
  linkedin:         '',
  evaluationReason: '',
};

const validateStep = async (stepIndex, values, { setErrors, setTouched }) => {
  try {
    await STEP_SCHEMAS[stepIndex].validate(values, { abortEarly: false });
    return true;
  } catch (yupError) {
    const fieldErrors  = {};
    const fieldTouched = {};
    yupError.inner.forEach(({ path, message }) => {
      fieldErrors[path]  = message;
      fieldTouched[path] = true;
    });
    setErrors(fieldErrors);
    setTouched(fieldTouched, false);
    return false;
  }
};

const buildPayload = (values) => {
  const { orgCountryCode, orgPhoneNumber, industry, industry_other, ...rest } = values;

  return {
    ...rest,
    industry: industry === 'Other' ? industry_other : industry,
    orgCountryCode,         
    orgPhoneNumber,          
  };
};

const OrganizationForm = ({ handleSubmit, goBackToStepOne }) => {
  const [activeStep, setActiveStep] = useState(0);
  const isLastStep = activeStep === STEPS.length - 1;

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={async (values, { setErrors, setSubmitting }) => {
        const valid = await validateStep(activeStep, values, {
          setErrors,
          setTouched: () => {},
        });
        if (!valid) { setSubmitting(false); return; }

        try {
          await handleSubmit(buildPayload(values));
        } catch (err) {
          setErrors({ submit: err.message });
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit: formikSubmit,
          isSubmitting, setErrors, setFieldValue, setTouched, touched, values }) => {

        const handleContinue = async () => {
          const valid = await validateStep(activeStep, values, { setErrors, setTouched });
          if (valid) setActiveStep((p) => p + 1);
        };

        const handleBack = activeStep === 0
          ? goBackToStepOne
          : () => setActiveStep((p) => p - 1);

        const stepProps = { values, errors, touched, handleBlur, handleChange };

        return (
          <form noValidate onSubmit={formikSubmit}>

            <OrganizationFormHeader
              activeStep={activeStep}
              isSubmitting={isSubmitting}
              onBack={handleBack}
            />

            <StepIndicator activeStep={activeStep} />

            <Box sx={{ minHeight: 200 }}>
              {activeStep === 0 && (
                <StepOne {...stepProps} setFieldValue={setFieldValue} />
              )}
              {activeStep === 1 && (
                <StepTwo {...stepProps} isSubmitting={isSubmitting} />
              )}
            </Box>

            {!isLastStep && (
              <Button
                disableElevation fullWidth size="large"
                variant="contained" color="primary" sx={{ mt: 3 }}
                onClick={handleContinue}
              >
                Continue
              </Button>
            )}

          </form>
        );
      }}
    </Formik>
  );
};

export default OrganizationForm;
